import { createAction, props } from '@ngrx/store';

export const showOpportunityError = createAction(
  '[Charter.Error] Show Error',
  props<{ error: string }>()
);
